import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'wsm-common-data';

const IncentiveTrims = ({ offer, overridePrefs }) => {
	const defaultPrefs = usePrefs();
	const labels = useLabels();
	const prefs = overridePrefs || defaultPrefs;
	const showTrimsInline =
		prefs.showIncentiveTrimsInOfferDetails === 'true' ||
		prefs.showIncentiveTrimsInOfferDetails === 'compliant';

	const { trims } = offer;

	if (!showTrimsInline || !trims?.length) return null;

	const formatTrimDisplay = (t) =>
		[t.year, t.make, t.model, t.bodyStyle, t.trim]
			.filter(Boolean)
			.join(' ');

	const deduped = [...trims]
		.filter((t) => t.trim)
		.reduce((acc, t) => {
			const display = formatTrimDisplay(t);
			if (!acc.has(display)) acc.set(display, t);
			return acc;
		}, new Map());

	const sortedTrims = [...deduped.values()].sort((a, b) =>
		formatTrimDisplay(a).localeCompare(formatTrimDisplay(b))
	);

	if (!sortedTrims.length) return null;

	const eligibleTrimsLabel = labels.get('INCENTIVES_ELIGIBLE_TRIMS');
	const countTemplate = labels.get('INCENTIVES_ELIGIBLE_TRIMS_COUNT');

	const countDisplay = countTemplate
		.replace('{count}', sortedTrims.length)
		.replace('(s)', sortedTrims.length !== 1 ? 's' : '');

	return (
		<div className="trims-inline mt-2 mb-2">
			<p className="ddc-font-size-small text-muted mb-1">
				{countDisplay}
			</p>
			<ul className="list-unstyled mb-0" aria-label={eligibleTrimsLabel}>
				{sortedTrims.map((t) => (
					<li
						key={formatTrimDisplay(t)}
						className="ddc-font-size-small"
					>
						{formatTrimDisplay(t)}
					</li>
				))}
			</ul>
		</div>
	);
};

IncentiveTrims.propTypes = {
	offer: PropTypes.shape({
		trims: PropTypes.arrayOf(
			PropTypes.shape({
				year: PropTypes.number,
				make: PropTypes.string,
				model: PropTypes.string,
				bodyStyle: PropTypes.string,
				trim: PropTypes.string
			})
		)
	}).isRequired,
	overridePrefs: PropTypes.shape({
		showIncentiveTrimsInOfferDetails: PropTypes.string
	})
};

IncentiveTrims.defaultProps = {
	overridePrefs: null
};

export default IncentiveTrims;
